(function () {
	'use strict';

	// navy-locale-redirects.js
	// 1) Calls /browsing_context_suggestions.json to detect user's country
	// 2) If country handle is 'JP' or 'KR' and no explicit locale cookie exists,
	//    redirect user to the corresponding locale prefix (/ja or /ko) and add currency param
	// 3) Sets a 1-year cookie `locale_preference` when we programmatically redirect (can be overwritten by manual switch)
	// 4) Preserves the current path (product, collection, etc.) and query string while switching locale

	var ENDPOINT = '/browsing_context_suggestions.json';
	var COOKIE_NAME = 'locale_preference';
	var COOKIE_DAYS = 365;
	var LOCALE_MAP = {
		JP: { locale: 'ja', currency: 'JPY' },
		KR: { locale: 'ko', currency: 'KRW' }
	};

	function getCookie(name) {
		var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
		return v ? decodeURIComponent(v.pop()) : null;
	}

	function currencyForLocale(locale) {
		if (!locale) return null;
		if (locale === 'ja') return 'JPY';
		if (locale === 'ko') return 'KRW';
		return null;
	}

	function isSupportedCookieLocale(locale) {
		if (!locale) return false;
		var supported = [];
		for (var k in LOCALE_MAP) {
			if (LOCALE_MAP.hasOwnProperty(k)) supported.push(LOCALE_MAP[k].locale);
		}
		return supported.indexOf(locale) !== -1;
	}


	function setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		var domain = location.hostname;
		// Set cookie for current host; don't attempt to set top-level domain automatically
		document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
	}

	// NOTE: preview/admin/designMode guard removed to allow testing.
	// The previous implementation skipped redirects in preview or design mode.
	// If you want that behavior back later, re-add the guard and early return in `run()`.

	function parseDetectedCountry(data) {
		if (!data) return null;
		// Support multiple possible response shapes
		if (data.detected_values && data.detected_values.country && data.detected_values.country.handle) {
			return data.detected_values.country.handle;
		}
		if (data.country && data.country.handle) return data.country.handle;
		return null;
	}

	function stripLocalePrefix(pathname) {
		// Remove leading /ja or /ko if present
		var m = pathname.match(/^\/(ja|ko)(?:\/|$)(.*)$/);
		if (m) {
			var rest = m[2] || '';
			return rest ? '/' + rest : '/';
		}
		return pathname || '/';
	}

	function buildRedirectUrl(targetLocale, targetCurrency, includeCurrency) {
		var loc = window.location;
		var pathname = loc.pathname || '/';
		var stripped = stripLocalePrefix(pathname);
		// Ensure leading slash
		if (!stripped.startsWith('/')) stripped = '/' + stripped;
		// If stripped is just '/', result should be '/{locale}' (no duplicate slashes)
		var newPath = stripped === '/' ? '/' + targetLocale + '/' : '/' + targetLocale + stripped;
		// Normalize double slashes
		newPath = newPath.replace(/\/+/g, '/');

		var url = new URL(loc.origin + newPath + loc.search + loc.hash);
		// Ensure currency param
		if (includeCurrency && targetCurrency) {
      // Not really needed, hide first
			// url.searchParams.set('currency', targetCurrency);
		}
		return url.toString();
	}

	function alreadyOnLocale(targetLocale) {
		var m = location.pathname.match(/^\/(ja|ko)(?:\/|$)/);
		return !!(m && m[1] === targetLocale);
	}

	function urlsEqualIgnoringHash(a, b) {
		try {
			var ua = new URL(a);
			var ub = new URL(b);
			ua.hash = '';
			ub.hash = '';
			return ua.toString() === ub.toString();
		} catch (e) {
			return a === b;
		}
	}

	function performRedirectIfNeeded(detectedHandle) {
		if (!detectedHandle) return;
		var mapping = LOCALE_MAP[detectedHandle];
		if (!mapping) return; // only handle JP and KR

		var existingPreference = getCookie(COOKIE_NAME);
		if (existingPreference) {
			// If cookie exists and matches detected country, check if already on correct locale
			if (existingPreference === mapping.locale) {
				var currentLocaleMatch = window.location.pathname.match(/^\/(ja|ko)(?:\/|$)/);
				var currentLocale = currentLocaleMatch ? currentLocaleMatch[1] : null;
				// If already on correct locale, preserve query params
				if (currentLocale === mapping.locale) {
					return;
				}
				// Only redirect if on wrong locale
				var newUrl = buildRedirectUrl(mapping.locale, mapping.currency, false);
				window.location.replace(newUrl);
			}
			return;
		}

		// No cookie: apply first-visit automatic redirect for detected countries
		if (alreadyOnLocale(mapping.locale)) {
			// Already on correct locale, do nothing (preserve query params)
			return;
		}

		// Build redirect target and redirect
		var redirectTo = buildRedirectUrl(mapping.locale, mapping.currency, true);
		// Set cookie so subsequent visits follow this choice (1 year)
		try {
			setCookie(COOKIE_NAME, mapping.locale, COOKIE_DAYS);
		} catch (e) {}

		if (!urlsEqualIgnoringHash(window.location.href, redirectTo)) {
			window.location.replace(redirectTo);
		}
	}

	function run() {
		// Check if this is right after a manual switch - if so, skip all logic
		try {
			if (sessionStorage.getItem('navy_manual_switch') === '1') {
				sessionStorage.removeItem('navy_manual_switch');
				return; // Skip all redirect logic after manual switch
			}
		} catch (e) {}
		
		// Running unguarded to allow testing in preview/admin environments.
		// Only run on GET page loads
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			// continue
		}

		// Priority: if a `locale_preference` cookie exists, honor it regardless of IP geolocation.
		try {
			var pref = getCookie(COOKIE_NAME);
			if (pref) {
				// If cookie is for supported locales (ja/ko) honor and redirect to it.
				if (isSupportedCookieLocale(pref)) {
					var currentLocaleMatch = window.location.pathname.match(/^\/(ja|ko)(?:\/|$)/);
					var currentLocale = currentLocaleMatch ? currentLocaleMatch[1] : null;
					
					// If already on correct locale, do nothing (preserve query params)
					if (currentLocale === pref) {
						return;
					}
					
					// Only redirect if on wrong locale
					var desiredUrl = buildRedirectUrl(pref, currencyForLocale(pref), false);
					window.location.replace(desiredUrl);
					return;
				} else if (pref === 'en') {
					// Cookie is 'en' - user wants English (no locale prefix)
					var currentLocaleMatch = window.location.pathname.match(/^\/(ja|ko)(?:\/|$)/);
					if (currentLocaleMatch) {
						// Currently on ja/ko but cookie says 'en' - redirect to remove locale prefix
						var stripped = stripLocalePrefix(window.location.pathname);
						var enUrl = window.location.origin + stripped + window.location.search + window.location.hash;
						window.location.replace(enUrl);
						return;
					}
					// Already on English (no prefix), do nothing
					return;
				} else {
					// Cookie exists but not for ja/ko/en — respect it and do not auto-redirect.
					return;
				}
			}
		} catch (e) {
			// ignore cookie errors and continue
		}

		// Call the endpoint (no-cache) and act on response
		var endpoint = (location.origin || window.location.protocol + '//' + window.location.host) + ENDPOINT;
		fetch(endpoint, { cache: 'no-store', credentials: 'same-origin' })
			.then(function (resp) {
				if (!resp.ok) throw new Error('Network response not ok');
				return resp.json();
			})
			.then(function (json) {
				var detected = parseDetectedCountry(json);
				performRedirectIfNeeded(detected);
			})
			.catch(function (err) {
				// Fail silently — do not break page experience
				console && console.debug && console.debug('navy-locale-redirects:', err.message || err);
			});
	}

	// Run on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}

	// --- Manual switch handling ---
	// When user manually switches language (mobile select or desktop options),
	// set the `locale_preference` cookie and ensure currency param is present.

	function getLocaleFromPathname(pathname) {
			// Only detect the supported locale prefixes (ja / ko).
			// Do not rely on any Liquid-injected globals; simply return the
			// matched locale or null when not present.
			var m = pathname.match(/^\/(ja|ko)(?:\/|$)/i);
			return m ? m[1].toLowerCase() : null;
	}

	function localeFromUrlObj(urlObj) {
		var path = urlObj.pathname || '/';
		var l = getLocaleFromPathname(path);
		if (l) return l;
		// If no ja/ko prefix present, default to English ('en').
		return 'en';
	}

	function ensureCurrencyForLocale(urlObj) {
		try {
			var locale = getLocaleFromPathname(urlObj.pathname);
			if (!locale) return urlObj;
			var currency = null;
			if (locale === 'ja') currency = 'JPY';
			if (locale === 'ko') currency = 'KRW';
			if (currency) urlObj.searchParams.set('currency', currency);
		} catch (e) {}
		return urlObj;
	}

	function handleManualLocaleChange(rawUrl) {
		try {
			
			var urlObj = new URL(rawUrl, location.origin);
			
			
			var detectedLocale = localeFromUrlObj(urlObj);

			// persist user's explicit choice for subsequent visits (always store the selected locale)
			try { 
				setCookie(COOKIE_NAME, detectedLocale, COOKIE_DAYS);
				// Set a flag to prevent run() from executing on the next page load
				sessionStorage.setItem('navy_manual_switch', '1');
			} catch (e) {
				console.error('[handleManualLocaleChange] Error setting cookie/storage:', e);
			}
			
			var finalUrl = urlObj.toString();
			
			// Do NOT force currency on manual switches — only initial auto-redirect sets currency.
			window.location.href = finalUrl;
		} catch (e) {
			console.error('[handleManualLocaleChange] Error:', e);
			window.location.href = rawUrl;
		}
	}


	// Expose manual handler so legacy theme JS can call it
	try {
		window.NavyLocaleRedirects = window.NavyLocaleRedirects || {};
		window.NavyLocaleRedirects.handleManualLocaleChange = handleManualLocaleChange;
	} catch (e) {}

})();

